/**
 * checks, if all Items of an array are matching with another array.
 * The second array must contain all items of the first array
 * @param {T} array1 - The main array. All items of this array must be included in array2
 * @param {U} array2 - This function returns true, if all items of array1 are included in this array
 * @param {keyof T} key1 - is optional - if array1 contains objects, define here which key should be taken for array1, to compare the items. If key1 is not specified, the function compares the values ​​of the elements directly (which is useful for simple types like strings or numbers).
 * @param {keyof T} key2 - is optional - if array2 contains objects, define here which key should be taken for array2, to compare the items. If key2 is not specified, the function compares the values ​​of the elements directly (which is useful for simple types like strings or numbers).
 *
 */
export const areAllItemsMatching = <T, U>(
  array1: T[],
  array2: U[],
  key1?: keyof T,
  key2?: keyof U
): boolean => {
  return array1.every((item1) =>
    array2.some(
      (item2) =>
        (key1 ? item1[key1]?.toString() : item1?.toString()) ===
        (key2 ? item2[key2]?.toString() : item2?.toString())
    )
  );
};

/**
 * checks, if any items of an array are matching with another array.
 * The second array must contain at least one items of the first array
 * @param {T} array1 - The main array
 * @param {U} array2 - This function returns true, if at least one item of array1 is included in this array
 * @param {keyof T} key1 - is optional - if array1 contains objects, define here which key should be taken for array1, to compare the items. If key1 is not specified, the function compares the values ​​of the elements directly (which is useful for simple types like strings or numbers).
 * @param {keyof T} key2 - is optional - if array2 contains objects, define here which key should be taken for array2, to compare the items. If key2 is not specified, the function compares the values ​​of the elements directly (which is useful for simple types like strings or numbers).
 *
 */
export const hasOverlappingItems = <T, U>(
  array1: T[],
  array2: U[],
  key1?: keyof T,
  key2?: keyof U
): boolean => {
  return array1.some((item1) =>
    array2.some(
      (item2) =>
        (key1 ? item1[key1]?.toString() : item1?.toString()) ===
        (key2 ? item2[key2]?.toString() : item2?.toString())
    )
  );
};
